export const environment = {
  production: true,
  api_url: 'https://apps.digivive.com/platform8_dynamic/',
  play_url:'https://apps.digivive.com/',
  // googleTrackingCode: 'UA-180910812-1',//stage.demo
  googleTrackingCode: 'G-Z1DPEHX946',
  BASE_ASSETS_PATH: 'https://res.cloudinary.com/digivive/image/upload/',
  APP_CLOUD_NAME: 'v1603711950',
  SRC_EXT :'.webp' ,
  platformType: '1',
  api_base_url:'https://apps.digivive.com/production/',
  device_time_interval:30000 // in seconds
};